import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormOperationKind } from "../../models/form-operation-kind.enums";
import { InvVoucherKind } from "../../models/inv-voucher-kind.model";
@Component({
  selector: "ngx-inv-subledger-detailLedger-form",
  templateUrl: "./inv-subledger-detailLedger-form.component.html",
  styleUrls: ["./inv-subledger-detailLedger-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvSubledgerDetailLedgerFormComponent extends BaseFormComponent<any> {
  @Input() Columns: form_control[] = [];
  @Input() CurrentVoucherKind: InvVoucherKind;
  @Input() detailLedgerLevel: number;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.label = "معین و تفصیلی";
    this.model = Object.assign({}, this.currentrow);
    this.prepareColumns();
  }
  addControl() {
    this.cd.markForCheck();
  }
  prepareColumns() {
    Object.assign(this.orignalColumns, this.Columns);
    this.orignalColumns.forEach((x) => (x.required = false));
    this.orignalColumns
      .filter((x) => x.name.startsWith("DetailLedger"))
      .forEach((x) => {
        if (x.name.includes("DetailLedgerId")) x.formVisible = this.detailLedgerLevel >= 1;
        if (x.name.includes("DetailLedger2Id")) x.formVisible = this.detailLedgerLevel >= 2;
        if (x.name.includes("DetailLedger3Id")) x.formVisible = this.detailLedgerLevel >= 3;
        if (x.name.includes("DetailLedger4Id")) x.formVisible = this.detailLedgerLevel >= 4;
        if (x.name.includes("DetailLedger5Id")) x.formVisible = this.detailLedgerLevel >= 5;
        if (x.name.includes("DetailLedger6d")) x.formVisible = this.detailLedgerLevel >= 6;
      });
    this.orignalColumns
      .filter((x) => x.name.startsWith("CostSubLedger") || x.name.startsWith("GoodsDetailLedger"))
      .forEach((x) => {
        if (x.name === "CostSubLedgerId")
          x.formVisible =
            this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseService ||
            this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsConsumptionVoucher;
        if (x.name.includes("GoodsDetailLedgerId"))
          x.formVisible =
            (this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseService ||
              this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsConsumptionVoucher) &&
            this.detailLedgerLevel >= 1;
        if (x.name.includes("GoodsDetailLedger2Id"))
          x.formVisible =
            (this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseService ||
              this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsConsumptionVoucher) &&
            this.detailLedgerLevel >= 2;
        if (x.name.includes("GoodsDetailLedger3Id"))
          x.formVisible =
            (this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseService ||
              this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsConsumptionVoucher) &&
            this.detailLedgerLevel >= 3;
        if (x.name.includes("GoodsDetailLedger4Id"))
          x.formVisible =
            (this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseService ||
              this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsConsumptionVoucher) &&
            this.detailLedgerLevel >= 4;
        if (x.name.includes("GoodsDetailLedger5Id"))
          x.formVisible =
            (this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseService ||
              this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsConsumptionVoucher) &&
            this.detailLedgerLevel >= 5;
        if (x.name.includes("GoodsDetailLedger6d"))
          x.formVisible =
            (this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsPurchaseService ||
              this.CurrentVoucherKind?.FormOperationKindCode === FormOperationKind.IsConsumptionVoucher) &&
            this.detailLedgerLevel >= 6;
      });

    this.columns = this.orignalColumns.filter(
      (x) => (x.name.includes("CostSubLedger") || x.name.includes("DetailLedger")) && !x.name.includes("Goods")
    );

    this.setColumnNumber(this.columns, 6);
    this.setFormGroup(this.model);
    this.cd.detectChanges();
  }
  public async save() {
    this.result = this.getDataFromFormGroup();
    this.close();
  }
  onvalueChangeByApiName($event) {
    if ($event) {
      this.model[$event.KeyName.replace("Id", "Code")] = $event.data.Code;
      this.model[$event.KeyName.replace("Id", "Title")] = $event.data.Title;
      this.setValue($event.KeyName.replace("Id", "Code"), $event.data.Code);
      this.setValue($event.KeyName.replace("Id", "Title"), $event.data.Title);
      this.setColumnAttribute();
    }
  }
}
